import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type Shipment } from '../../api/logistics';

export function ShipmentsPage() {
  const [shipments, setShipments] = useState<Shipment[]>([]);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void logisticsApi.listShipments().then(setShipments).catch((e) => setError(String(e)));
  }, []);

  async function createSample() {
    try {
      const sh = await logisticsApi.createShipment({
        order_id: `ORD-${Date.now()}`, origin_pincode: '110001', dest_pincode: '400001', weight: 1.8,
      });
      await logisticsApi.assignCarrier(sh.id, 'delhivery');
      await logisticsApi.generateAWB(sh.id);
      setMsg(`Created ${sh.shipment_number}`);
      setShipments(await logisticsApi.listShipments());
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/logistics" className="text-sm text-slate-600 hover:underline">← Logistics hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Shipment manager</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createSample()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Create sample shipment</button>
      <ul className="mt-6 space-y-2">
        {shipments.map((s) => (
          <li key={s.id} className="rounded-lg border p-3 text-sm">
            <span className="font-mono">{s.shipment_number}</span> — {s.status}
            {s.carrier_code && <> · {s.carrier_code}</>}
            {s.awb_number && <> · AWB {s.awb_number}</>}
          </li>
        ))}
      </ul>
    </div>
  );
}
